//no-unused-vars
import React, {Component} from 'react';
import AddAbstractDeadlineToUserCallendar from './MyCallendar';
import HCS2021ProgramAbstractsPDF from "./HCS2021_program-abstracts_2021-11-10.pdf";

//import Calendar from 'react-google-calendar';
//import ApiCalendar from 'react-google-calendar-api';

//import MathJax from 'react-mathjax2'

//const var CalendarProps;


export const ProgrammePage = () => (
  <div className='container'>
		<div class="row">		
			&nbsp;
		</div>
	
		<div class="row">
			<div class="col-md-12 justify-content-center">
					<h2>Programme</h2> 
			</div>
		</div>
		
		<div class="row">		
			&nbsp;
		</div>	
			
		<div class="row">
			<div class="col-md-12 justify-content-center">
				<p><b>Program 2021</b> (<a href={HCS2021ProgramAbstractsPDF} >PDF file</a>).</p>
			</div>
			<div class="col-md-12 justify-content-center">
				<p><b>Program 2023 in preparation.</b>.</p>
			</div>
		</div>	
			
		<div class="row">		
			&nbsp;
		</div>
	
					
		<div class="row">
			<br/><br/><br/>&nbsp;
			<h4>Time schedule:</h4> 			
		</div>	
			
			
		<div class="row">
			<div class="col-md-12">
					11 November 
			</div>
		</div>
		<div class="row">
			<div class="col-md-2">
				9:00-20:00
			</div>
			<div class="col-md-10">					
				Sessions
			</div>
		</div>
		<div class="row">
			&nbsp;
		</div>
		
		<div class="row">
			<div class="col-md-12">
					12 November 
			</div>
		</div>
		<div class="row">
			<div class="col-md-2">
				9:00-21:30
			</div>
			<div class="col-md-10">					
				Sessions
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
			</div>
		</div>
		<div class="row">
			&nbsp;
		</div>
		
		<div class="row">
			<div class="col-md-12">
					13 November 
			</div>
		</div>
		<div class="row">
			<div class="col-md-2">
				9:00-21:00
			</div>
			<div class="col-md-10">					
				Sessions
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
			</div>
		</div>
		<div class="row">
			&nbsp;
		</div>
		
		<div class="row">
			<div class="col-md-12">
					14 November 
			</div>
		</div>
		<div class="row">
			<div class="col-md-2">
				9:00-21:00
			</div>
			<div class="col-md-10">					
				Sessions
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
			</div>
		</div>
		<div class="row">
			&nbsp;
			<p><b>Hours are given according to <a href="https://time.is/pl/Poland">Polish time</a>.</b></p>
		</div>
		
	</div>	
);
 
 
export const ProgrammePageNew = () => (
  <div className='container'>
		<div class="row">		
			&nbsp;
		</div>	
			
		<div class="row">		
			&nbsp;
		</div>
	
		
		<div class="row">
			<div class="col-md-12">
					<h3>Opening of the Seminar</h3> 
					<p>prof. Maria Ławrynowicz, prof. Paweł Kowalczyk, prof. Józef Zając</p>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
					<h3>Section A: Mathematics</h3> 
					<b>Invited lectures:</b>					
					<ol>				
					<li>Massimo Vaccaro "Sp(n)-orbits of isoclinic subspaces in the real Grassmannians"</li>
					<li>Sergiy Plaksa, "Monogenic functions in a harmonic algebra"</li>
					<li>Lino. F. Resendis "Bicomplex Bergman Projection"</li>
					</ol>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
					<h3>Section B: Physics and Statistics</h3> 
					<b>Invited lectures:</b>
					<ol>				
					<li>Jacek Leśkow, "Cyclostationary time series. Functional data analysis and time series"</li>
					<li>Paulius Miskinis, "On one class of completely integrable evolutionary models"</li>
					<li>Zhidong Zhang, "Exact solution of ferromagnetic 3D Ising model and computational complexity of spin-glass 3D Ising system"</li>
					</ol>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
					<h3>Section C: Informatics</h3> 
					<b>Invited lectures:</b>
					<ol>				
					<li>Witold Dzwinel, TBA</li>
					<li>Maciej Jaworski, TBA</li>
					<li>Radosław Kycia, "Clusterization in action"</li>
					</ol>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
					<h3>Section D: Classical and Quantum Electronics</h3> 
					<b>Invited lectures:</b>
					<ol>				
					<li>Mikhail Belogovskyi, "Superconducting Electronics"</li>
					<li>Kh. P. Gnatenko, TBA</li>					
					</ol>
			</div>
		</div>
	</div>	
); 

 
//export default ProgrammePage
